import { NavigationExtras, Router } from '@angular/router';
import { inject } from '@angular/core';
import { base64Encode } from '@softline/core';

export interface NavigateOptions extends NavigationExtras {
  origin?: boolean | string;
}

export type NavigateFn = (commands: any[], extras?: NavigateOptions) => Promise<boolean>;

export function navigateFn(): NavigateFn {
  const router = inject(Router);

  return (commands, extras?: NavigateOptions) => {
    const { origin: _origin, ...navigationExtras } = extras ?? {};

    let origin = _origin;

    if (origin && typeof origin === 'boolean') {
      origin = base64Encode(router.url);
    }

    return router.navigate(commands, {
      ...navigationExtras,
      queryParams: {
        ...(navigationExtras?.queryParams ?? {}),
        ...(origin ? { origin } : {}),
      },
    });
  };
}
